import { Api } from "@mcleod/core";
import { ChangeEvent } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutCompany } from "./autogen/AutogenLayoutCompany";

export class Company extends AutogenLayoutCompany {

    /** This is an event handler for the onChange event of checkboxAllowKeepSignedIn.  */
    checkboxAllowKeepSignedInOnChange() {
        this.syncKeepSignedInDaysTextbox();
    }

    /** This is an event handler for the afterExecution event of sourceLoginSettings. */
    sourceLoginSettingsAfterExecution() {
        this.syncKeepSignedInDaysTextbox();
    }

    private syncKeepSignedInDaysTextbox() {
        this.textboxKeepSignedInDays.enabled = this.checkboxAllowKeepSignedIn.checked;
    }

    buttonSendTestEmailOnClick(event) {
        if( this.textboxTo.text == null || this.textboxTo.text == "" ){
            CommonDialogs.showError("A \"To\" address must be entered to send a test message.");
            return;
        }
        return Api.post("lme/general/send-email", {
            test_email_host: this.textboxEmailHost.text,
            test_email_from: this.textboxFrom.text,
            test_email_protocol: this.textboxProtocol.text,
            test_email_port: this.textboxEmailPort.text,
            test_email_user: this.textboxEmailUsername.text,
            test_email_password: this.textboxEmailPassword.text,
            to_address: this.textboxTo.text,
            cc_address: this.textboxCC.text,
            subject: this.textboxSubject.text,
            plain_text: this.textboxMessage.text
        }).then(response => {
            if (response.data == null && response.data.length !== 1)
                return Promise.reject("There was an error attempting to open a classic screen.");
            return Promise.resolve();
        });
    }

    /** This is an event handler for the onChange event of textboxEmail. */
    textboxEmailOnChange(event: ChangeEvent) {
        this.textboxFrom.text=this.textboxEmail.text;
    }

    
}
